import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { GET } from "../../services/axios.service";
import { RootState } from "../../app/store";
import { JobworksPartiesProps } from "../../types/jobworksParties";

export interface JobworksPartiesState {
  jobworksParties: JobworksPartiesProps[];
  totalParties: number;
  totalPendingAmount: number;
  totalReceivedAmount: number;
  isPartyModalOpen: boolean;
  editParty: JobworksPartiesProps | null;
  loading: boolean;
  error: string | null;
}

const initialState: JobworksPartiesState = {
  jobworksParties: [],
  totalParties: 0,
  totalPendingAmount: 0,
  totalReceivedAmount: 0,
  isPartyModalOpen: false,
  editParty: null,
  loading: false,
  error: null,
};

type FetchJobworksPartiesListDataProps = {
  page: number;
  size?: number;
  fromDate?: string | null;
  toDate?: string | null;
  search?: string | null;
  type?: number | null;
};

export const fetchJobworksPartiesListData = createAsyncThunk(
  "fetchJobworksPartiesListData",
  async (req: FetchJobworksPartiesListDataProps) => {
    let response: any;
    await GET(`/v1/admin/jobworks-parties`, { ...req })
      .then((res: any) => {
        response = res;
      })
      .catch((err) => {
        response = err;
      });
    return response;
  }
);

export const jobworksPartiesSlice = createSlice({
  name: "jobworksParties",
  initialState,
  reducers: {
    togglePartyModal: (state, action: PayloadAction<boolean>) => {
      state.isPartyModalOpen = action.payload;
    },
    setEditParty: (
      state,
      action: PayloadAction<JobworksPartiesProps | null>
    ) => {
      state.editParty = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchJobworksPartiesListData.pending,
      (state, action: any) => {
        state.jobworksParties = [];
        state.loading = true;
        state.error = null;
      }
    );
    builder.addCase(
      fetchJobworksPartiesListData.fulfilled,
      (state, action: any) => {
        state.loading = false;
        if (action.payload.data.status === "success") {
          state.jobworksParties = action.payload.data.data.records;
          state.totalParties = action.payload.data.data.total_records;
          state.totalPendingAmount =
            action.payload.data.data.total_pending_amount;
          state.totalReceivedAmount =
            action.payload.data.data.total_received_amount;
          state.error = null;
        } else {
          state.jobworksParties = [];
          state.totalPendingAmount = 0;
          state.totalReceivedAmount = 0;
          state.error =
            action?.payload?.data?.message ||
            "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
        }
      }
    );
    builder.addCase(
      fetchJobworksPartiesListData.rejected,
      (state, action: any) => {
        state.jobworksParties = [];
        state.loading = false;
        state.error =
          action?.payload?.data?.message ||
          "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
      }
    );
  },
});

export const { togglePartyModal, setEditParty } = jobworksPartiesSlice.actions;

export const getJobworksParties = (state: RootState) =>
  state.jobworksParties.jobworksParties;

export const getTotalParties = (state: RootState) =>
  state.jobworksParties.totalParties;

export const getTotalPendingAmount = (state: RootState) =>
  state.jobworksParties.totalPendingAmount;

export const getTotalReceivedAmount = (state: RootState) =>
  state.jobworksParties.totalReceivedAmount;

export const getIsPartyModalOpen = (state: RootState) =>
  state.jobworksParties.isPartyModalOpen;

export const getEditParty = (state: RootState) =>
  state.jobworksParties.editParty;

export default jobworksPartiesSlice.reducer;
